export default __webpack_public_path__ + "static/media/wristbands_of_the_whispering_blade.c00998e6.jpg";